import React, { useState } from "react"
import styled from "@emotion/styled"
import { navigate } from "@reach/router"

import { useAuth } from "../../hooks/auth-context"
import KYC from "../../services/kyc"

import WarningIconColor from "../ui/images/warning-icon-color"
import CustomButtonV2 from "../ui/custom-button-v2"
import { css } from "@emotion/react"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  margin: 50px auto;
  max-width: 490px;
`

const Title = styled.h3`
  text-align: center;
  font-family: Open Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 116%;
`
const WarningMessage = styled.p`
  text-align: center;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const ContainerAcceptance = styled.div`
  background-color: #fff0d2;
  padding: 10px 20px;
  margin-bottom: 10%;
`
const Acceptance = styled.p`
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.1px;
`

const saveButtonStyle = css`
  margin-top: 1.5rem;
  padding: 12px 48px;
  width: 260px;
  background-color: #2ba770;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
`

const loadingButtonStyle = saveButtonStyle


const BadTraderProfile = () => {
  const { state } = useAuth()
  const { user, setUser } = state
  const [isLoading, setIsLoading] = useState(false)

  const handleConfirm = async () => {
    if (isLoading) return
    setIsLoading(true)

    const result = await KYC.updateRiskBadTraderProfile(user as User)
    console.log(result)

    setUser(result.user)
    setIsLoading(false)
    navigate(`/${result.user.kycNextStep}`)
  }

  return (
    <Container>
      <WarningIconColor />
      <Title>
        Antes de continuar...
      </Title>
      <WarningMessage>
        Tu perfil actual no encaja del todo con el nivel de experiencia o riesgo asociado al trading. Igual puedes seguir. Solo necesitamos que confirmes que entiendes los riesgos y quieres continuar bajo tu responsabilidad.
      </WarningMessage>
      <ContainerAcceptance>
        <Acceptance>
          Declaro que comprendo los riesgos del trading y que, aunque mi perfil no es el ideal para este tipo de producto, deseo continuar con la apertura de mi cuenta con Capitaria bajo mi responsabilidad.
        </Acceptance>
      </ContainerAcceptance>
      <CustomButtonV2
        type="button"
        onClick={handleConfirm}
        loading={isLoading}
        style={saveButtonStyle}
        loadingStyle={loadingButtonStyle}
      >
        Confirmar y continuar
      </CustomButtonV2>
    </Container>
  )
}

export default BadTraderProfile
